import Vue from "vue";
import VueRouter from "vue-router";
import jwtDecode from "jwt-decode";
import moment from "moment-timezone";
import rolesRouter from "../views/admin/roles/rolesRouter";
import profilesRouter from "../views/admin/profiles/profilesRouter";
import usersRouter from "../views/admin/users/userRouter";
import pathsRouter from "../views/admin/paths/pathRouter";
import ingresosRoutes from "../views/catalogos/ingresos/router";
import deduccionesRoutes from "../views/catalogos/deducciones/router";
// import planillaRoutes from "../views/planilla/router";
import solicitudFondosRoutes from "../views/solicitudFondos/router";
import catalogosGeneralesRouter from "../views/catalogos/catalogosRouter";
import estructuraRouter from "../views/estructura/estructuraRouter";
import configuracionParametrosSistemaRoutes from "../views/configuracionParametrosSistema/router";
import nomina from "../views/nomina/router";
import solicitudFunciones from "../views/solicitud-funciones/routes/index.js";
import PuestoUnidadRouter from "../views/puestoUnidad/puestoUnidadRouter";
import organigramaInstitucional from "../views/organigrama/router";
import accionesMovimientosRouter from "../views/acciones-movimientos/accionesMovimientosRouter";
import renunciasRouter from "../views/renuncias/renunciasRouter";
import reportesRouter from "../views/reportes/reportesRouter";
import agrupadoresPlazasRoutes from '../../src/views/catalogos/catalogoAgrupadoresPlaza/router/index';
import comisionRouter from '../views/comision/router';
import gestionRoles from '../views/gestionRoles/router';
import refrendaRouter from '@/views/acciones-movimientos/v2/refrenda/router/index.js';
import exoneracionMarcacionRoutes from "../views/acciones-movimientos/exoneracion_marcacion/routes/exoneracionMarcacionRoutes";
import amonestacionesRouter from "../views/acciones-movimientos/amonestacion/router";
import licenciaRouter from "../views/acciones-movimientos/licencia/licenciaRouter";
import plazasHistorialRouter from "../views/historialPlazas/router";
import gestionAccionesRouter from "../views/roles-perfiles/gestionAcciones/router"
import perfilesRouter from "../views/roles-perfiles/perfiles/perfilesRouter";
import asignacionPerfilRouter from "../views/roles-perfiles/asignacionPerfiles/asignacionPerfilRouter";
import historialEmpleadosRouter from "../views/historialEmpleados/router";
import authServices from "../services/auth.services";
import historicoContratoRouter from "../views/nomina/historicoContratos/router";
import agruparAccionesRouter from "../views/roles-perfiles/agruparAcciones/agruparAccionesRouter";
import configuracionesAdicionalesRouter from "../views/planilla/configuraciones-adicionales/router/configuracionesAdicionalesRouter";
import planillaRouter from "../views/planilla/gestion-planilla/router/index.js";
import institucionEstablecimientoRouter from "../views/institucion-establecimiento/institucionEstablecimientoRouter.js";
import sancionesRoutes from "../views/sanciones/sancionesRoutes.js";
import solicitudesAumentoSalarialRouter from '../views/solicitudes/aumentoSalario/router.js'
import ramoRoutes from '../views/ramo/router/index.js'
import renunciasRRHHRouter from "../views/solicitudes/renuncia/renunciasRouter.js";
import decretosSolicitudes from "../views/solicitudes/decretos/decretos.js";
import procesoRouter from "../views/solicitudes/proceso/procesoRouter.js";
import catalogoEstablecimientosRoutes from "../views/catalogos/catalogoEstablecimiento/router/index.js";
import ConfiguracionInstitucionRouter from "../views/configuracionInstitucion/router.js";
import { hasRole } from "../plugins/security.js";
// import usuariosTitularService from "../views/usuariosTitulares/router.js";
import responsablesPlanillaRoutes from "../views/planilla/responsable/router/index.js";
import historicosRentaRouter from "../views/planilla/historicos-renta/router/index.js";
import quincenaVeinticincoRouter from "../views/planilla/quincena-veinticinco/router/index.js";
import directorioRouter from "../views/directorio/directorioRouter.js";
import despidosV2Router from "../views/despidosV2/router.js";
import presupuestoRouter from "../views/presupuesto/router/index.js";
import constanciasRoutes from "../views/constancias/routes.js";
import horasExtrasRouter from "../views/horasExtras/router.js";
import consultoriasRouter from "../views/consultorias/consultoriasRouter.js";
import escalafonRouter from "../views/escalafon/router/index.js";
import bolsonPagosRouter from "../views/bolsonPagos/router.js";
import reportesEmpleadoRouter from "../views/reportesEmpleado/router.js";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "menu",
    component: () =>
      import(/* webpackChunkName: "profiles" */ "../views/menu"),
  },
  {
    path: "/",

    component: () => import(/* webpackChunkName: "layout" */ "../views/layout"),

    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () =>
          import(/* webpackChunkName: "profiles" */ "../views/dashboard"),
      },
      {
        path: "profile",
        name: "profile",
        component: () =>
          import(/* webpackChunkName: "profiles" */ "../views/profile"),
      },
      ...rolesRouter,
      ...profilesRouter,
      ...usersRouter,
      ...pathsRouter,
      ...ingresosRoutes,
      ...deduccionesRoutes,
      ...planillaRouter,
      // ...planillaRoutes,
      ...solicitudFondosRoutes,
      ...catalogosGeneralesRouter,
      ...estructuraRouter,
      ...configuracionParametrosSistemaRoutes,
      ...nomina,
      ...solicitudFunciones,
      ...PuestoUnidadRouter,
      ...organigramaInstitucional,
      ...accionesMovimientosRouter,
      ...renunciasRouter,
      ...reportesRouter,
      ...agrupadoresPlazasRoutes,
      ...comisionRouter,
      ...gestionRoles,
      ...refrendaRouter,
      ...exoneracionMarcacionRoutes,
      ...amonestacionesRouter,
      ...licenciaRouter,
      ...plazasHistorialRouter,
      ...gestionAccionesRouter,
      ...perfilesRouter,
      ...asignacionPerfilRouter,
      ...historialEmpleadosRouter,
      ...historicoContratoRouter,
      ...agruparAccionesRouter,
      ...configuracionesAdicionalesRouter,
      ...institucionEstablecimientoRouter,
      ...sancionesRoutes,
      ...solicitudesAumentoSalarialRouter,
      ...ramoRoutes,
      ...renunciasRRHHRouter,
      ...procesoRouter,
      ...decretosSolicitudes,
      ...catalogoEstablecimientosRoutes,
      ...despidosV2Router,
      ...ConfiguracionInstitucionRouter,
      // ...usuariosTitularService,
      ...responsablesPlanillaRoutes,
      ...historicosRentaRouter,
      ...quincenaVeinticincoRouter,
      ...directorioRouter,
      ...presupuestoRouter,
      ...constanciasRoutes,
      ...horasExtrasRouter,
      ...escalafonRouter,
      ...consultoriasRouter,
      ...bolsonPagosRouter,
      ...reportesEmpleadoRouter,
      {
        path: "/security",
        name: "security",
        component: () =>
          import(/* webpackChunkName: "qr" */ "../views/auth/security"),
      },
      {
        path: "/main-config-institucion",
        name: "configInstitucion",
        component: () =>
          import(/* webpackChunkName: "configInstitucion" */ "../views/admin/institucion/configInstitucionView.vue"),
      },
    ],

  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/auth/login"),
  },
  {
    path: "/formulario-seleccion/plaza",
    name: "formulario-seleccion-plaza",
    component: () =>
      import(/* webpackChunkName: "formulario-seleccion-plaza" */ "../views/acciones-movimientos/formulario_seleccion_plaza/index.vue"),
  },
  {
    path: "/formulario-seleccion/error",
    name: "formulario-seleccion-plaza-error",
    component: () =>
      import(/* webpackChunkName: "formulario-seleccion-plaza" */ "../views/acciones-movimientos/formulario_seleccion_plaza/views/tokenInvalido.vue"),
  },
  {
    path: "/formulario-seleccion/confirmacion",
    name: "formulario-seleccion-plaza-confirmacion",
    component: () =>
      import(/* webpackChunkName: "formulario-seleccion-plaza" */ "../views/acciones-movimientos/formulario_seleccion_plaza/views/confirmacionView.vue"),
  },
  {
    path: "/formulario-seleccion/rechazo",
    name: "formulario-seleccion-plaza-rechazo",
    component: () =>
      import(/* webpackChunkName: "formulario-seleccion-plaza" */ "../views/acciones-movimientos/formulario_seleccion_plaza/views/confirmacionView.vue"),
  },
  // ...formSeleccionPlazaRoutes,
  {
    path: "/seleccionar-puestos",
    name: "seleccionar-puestos",
    component: () =>
      import(/* webpackChunkName: "seleccionar-puesto" */ "../views/auth/puestos"),
  },
  {
    path: "/forbidden",
    name: "Forbidden",
    component: () =>
      import(/* webpackChunkName: "forbidden" */ "../views/forbidden"),
  },
  {
    path: "/errors/:uuid",
    name: "Errors",
    component: () =>
      import(/* webpackChunkName: "forbidden" */ "../views/errors"),
  },
  {
    path: "/visualizar-carnet-qr/:uuid",
    name: "VisualizarQr",
    component: () =>
      import(/* webpackChunkName: "visualizar-qr" */ "../views/nomina/VisualizarQrNomina.vue"),
  },
  {
    path: "/verificar-documento/:uuid",
    name: "verificardocumento",
    component: () =>
      import(/* webpackChunkName: "verificar-documento" */ "../views/acciones-movimientos/traslados/views/VerificarDocumento.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  let token = localStorage.getItem("token");
  const session = to.query.session;

  if (session) {
    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");
    localStorage.setItem("session_uuid", session);
    const queryWithoutSession = { ...to.query };
    delete queryWithoutSession.session;
    token = localStorage.getItem("token");

    if (!token) {
      try {
        const response = await authServices.obtenerSesionPorUUID(session);
        if (response.data?.token) {
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("refreshToken", response.data.refresh_token);
          token = response.data.token;
        }
      } catch (error) {
        console.error("Error al obtener la sesión:", error);
      }
    }

    next({ path: to.path, query: queryWithoutSession, replace: true });

    return;
  }
  if (to.matched.length == 0) {
    next("/dashboard");
    return;
  }

  if (to.path === "/") {
    next();
    return;
  }

  const noAuth = ["login", "verifyMail", "reset-password", "forgot-password", "dashboard", "formulario-seleccion-plaza", "formulario-seleccion-plaza-error", "formulario-seleccion-plaza-confirmacion", "formulario-seleccion-plaza-rechazo", "VisualizarQr", "verificardocumento"];
  if (to.name !== 'steps') {
    localStorage.removeItem('stepNumber')
  }

  if (!token && !noAuth.includes(to.name)) {
    next("/login");
    return;
  } else {
    if (!token && noAuth.includes(to.name)) {
      next();

      return;
    }

    // Cubre el caso en que existe un token en localStorage (expirado o inválido de una sesión anterior)
    // y el usuario accede a una ruta pública (ej. escaneo de QR sin sesión activa).
    // Sin este check, el flujo llegaría al jwtDecode() de abajo y lanzaría InvalidTokenError.
    // Solo aplica a rutas en el array noAuth — las rutas privadas no pasan por aquí
    // y siguen requiriendo token válido como siempre. // previene el caso que  se requiera que la vista sea publica pero se tenga un token invalido entonces previene ese posible error sin comprometer lo demas (rutas que si requieren auth)
    if (noAuth.includes(to.name)) {
      next();
      return;
    }

    const userDecode = jwtDecode(token);
    let expiracion = moment(new Date(userDecode.exp * 1000));
    let actual = moment(new Date(Date.now()));
    if (
      actual.diff(expiracion, "days") > 0 ||
      actual.diff(expiracion, "hours") > 0 ||
      actual.diff(expiracion, "minutes") > 0
    ) {
      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      next("/login");
    } else {

      const roles = JSON.parse(localStorage.getItem("roles")) || [];

      // Habilita que una ruta pueda declarar sus roles requeridos mediante meta.requiredRoles
      const requiredRoles = Array.from(
        new Set(
          to.matched
            .map((routeRecord) => routeRecord.meta?.requiredRoles)
            .filter(Boolean)
            .flatMap((role) => (Array.isArray(role) ? role : [role]))
        )
      );

      if (requiredRoles.length > 0) {
        const missingRole = requiredRoles.find((requiredRole) => !roles.includes(requiredRole));
        if (missingRole) {
          next('/dashboard');
          return;
        }
      }

      const routePermissions = {
        'estructura': 'ROL_CONFIGURADOR_INICIAL',
        'estructura-historial-empleado': 'ROL_CONFIGURADOR_INICIAL',
        'estructura-historial-destacado': 'ROL_CONFIGURADOR_INICIAL',
        'gestion-planilla': 'VIEW_PLANILLA_GESTION_PLANILLAS',
        'quincena-veinticinco': 'CONFIGURACIONES_ADICIONALES_AGUINALDO',
        'nomina': 'VIEW_GESTION_EMPLEADOS_EXPEDIENTES',
        'menu-reporte': 'VIEW_REPORTES_PLANILLA',
        'reportes-dinamicos': 'VIEW_REPORTES_PLANILLA',
        'crear-reporte-dinamico': 'VIEW_REPORTES_PLANILLA',
        'reporte-dinamico': 'VIEW_REPORTES_PLANILLA',
        'reporte-general-personalizado': 'VIEW_REPORTE_DINAMICO',
        'reporte-general-personalizado-detalle': 'VIEW_REPORTE_DINAMICO',

        // rutas sanciones
        'sanciones': 'ROLE_SANCIONES_VER_LISTA_JEFE_UNIDAD',
        'sanciones-solicitud': 'ROLE_SANCIONES_JEFE_AREA_REPORTE_CREAR',
        'sanciones-expediente': 'ROLE_SANCIONES_VER_LISTA_JEFE_UNIDAD',
        'sanciones-visualizar': 'ROLE_SANCIONES_VER_LISTA_JEFE_UNIDAD',
        'expediente-visualizar': 'ROLE_SANCIONES_VER_LISTA_JEFE_UNIDAD',

        'sanciones-titular': 'ROLE_SANCIONES_VER_LISTA_TITULAR',
        'sanciones-titular-solicitud': 'ROLE_SANCIONES_VER_LISTA_TITULAR',
        'sanciones-titular-expediente': 'ROLE_SANCIONES_VER_LISTA_TITULAR',

        'unidad-juridica-view': 'ROLE_SANCIONES_VER_LISTA_JURIDICO',
        'resoluciones': 'ROLE_SANCIONES_VER_LISTA_JURIDICO',
        'detallehistorial': 'ROLE_SANCIONES_VER_LISTA_JURIDICO',

        'sanciones-rrhh': 'ROLE_SANCIONES_VER_LISTA_RRHH',
        'sanciones-rrhh-solicitud': 'ROLE_SANCIONES_VER_LISTA_RRHH',
        'sanciones-rrhh-historial-detalle': 'ROLE_SANCIONES_VER_LISTA_RRHH',

        //Refrenda
        'refrenda': ['ROL_REFRENDA_FLUJO_TITULAR', 'ROL_REFRENDA_FLUJO_ENTE_RECTOR', 'ROL_REFRENDA_FLUJO_HACIENDA', 'ROL_REFRENDA_FLUJO_RRHH'],
        'refrenda-configuracion': ['ROL_REFRENDA_FLUJO_TITULAR', 'ROL_REFRENDA_FLUJO_ENTE_RECTOR', 'ROL_REFRENDA_FLUJO_HACIENDA', 'ROL_REFRENDA_FLUJO_RRHH'],
        'refrenda-iniciar-proceso': ['ROL_REFRENDA_FLUJO_RRHH'],

        //Presupuesto
        'presupuesto': ['ROL_FLUJO_UFI_PRESUPUESTO', 'ROL_FLUJO_MOVIMIENTO_PRESUPUESTO_TITULAR', 'ROL_FLUJO_MOVIMIENTO_PRESUPUESTO_DIRECTOR'],
        'presupuesto-anual': ['ROL_FLUJO_UFI_PRESUPUESTO', 'ROL_FLUJO_MOVIMIENTO_PRESUPUESTO_TITULAR', 'ROL_FLUJO_MOVIMIENTO_PRESUPUESTO_DIRECTOR'],
        'detalle-cifrado-anual': ['ROL_FLUJO_UFI_PRESUPUESTO', 'ROL_FLUJO_MOVIMIENTO_PRESUPUESTO_TITULAR', 'ROL_FLUJO_MOVIMIENTO_PRESUPUESTO_DIRECTOR'],
        'asignacion-presupuesto-anual': ['ROL_FLUJO_UFI_PRESUPUESTO', 'ROL_FLUJO_MOVIMIENTO_PRESUPUESTO_TITULAR', 'ROL_FLUJO_MOVIMIENTO_PRESUPUESTO_DIRECTOR'],
        'cifrados-presupuesto-anual': ['ROL_FLUJO_UFI_PRESUPUESTO', 'ROL_FLUJO_MOVIMIENTO_PRESUPUESTO_TITULAR', 'ROL_FLUJO_MOVIMIENTO_PRESUPUESTO_DIRECTOR'],
        'movimientos-presupuesto-anual': ['ROL_FLUJO_UFI_PRESUPUESTO', 'ROL_FLUJO_MOVIMIENTO_PRESUPUESTO_TITULAR', 'ROL_FLUJO_MOVIMIENTO_PRESUPUESTO_DIRECTOR'],

        // consultoria ROL CONSULTOR
        'consultorias-gestion-empleado':'ROLE_CNS_CONSULTOR_CONTROL_ACTIVIDADES',
        'consultorias-registro-actividades': 'ROLE_CNS_CONSULTOR_CONTROL_ACTIVIDADES',
      
        // consultoria ROL RRHH
        // gestion de entregables
        'consultorias-crearEntregablesRrhh':['ROLE_CNS_RRHH_CONSULTORIA','ROLE_CNS_JEFE_CONSULTORIA'],
        'consultorias-detalleEntregable' :['ROLE_CNS_RRHH_CONSULTORIA','ROLE_CNS_JEFE_CONSULTORIA'],
        'consultorias-designarConsultores':['ROLE_CNS_RRHH_CONSULTORIA','ROLE_CNS_JEFE_CONSULTORIA'],

        // consultoria ROL JEFE RRHH
        // prorrogas
        'consultoria-prorrogaEntregable': 'ROLE_CNS_JEFE_RRHH_CONSULTORIA_PRORROGAS',

        // escalafon
        'escalafon': 'ROL_GESTION_ESCALAFON',
        'configuracion-escalafon': 'ROL_GESTION_ESCALAFON'

      };

      const routeKey = to.name || to.path;

      if (routePermissions[routeKey]) {
        const requiredRoles = Array.isArray(routePermissions[routeKey])
          ? routePermissions[routeKey]
          : [routePermissions[routeKey]];

        if (!requiredRoles.some(role => roles.includes(role))) {
          next('/dashboard');
          return;
        }
      }

      next();
    }
  }
});

export default router;
